<div
  class="sz-search-input"
  [class.sz-search-input--disabled]="disabledState()"
  [class.sz-search-input--filled]="value().length > 0">
  <sz-icon class="sz-search-input__icon" name="search" [size]="18" />
  <input
    class="sz-search-input__input"
    type="search"
    [placeholder]="placeholder()"
    [value]="value()"
    [disabled]="disabledState()"
    (input)="onInput($event)"
    (blur)="onBlur()" />
  @if (value().length > 0 && !disabledState()) {
    <button type="button" class="sz-search-input__clear" aria-label="Clear" (click)="clear()">
      <sz-icon name="x" [size]="14" />
    </button>
  }
</div>
